import { FC } from 'react';
import { GameCardContainerType } from '../../GameCard/GameCard.types';
import { Grid, GridItem } from '../../../shared/Grid';
import { useBreakpointInfo, MediaBreakpoint } from '../../../../hooks/useDeviceInfo';
import { renderGameCard, BaseLayoutProps } from '../utils';
import { TALL_WIDE_LAYOUT_GAMES_COUNT } from '../../../../utils/games/createTileRowCollections';

type TallLayoutProps = BaseLayoutProps;

export const TallLayout: FC<TallLayoutProps> = ({ games, getCompositeKey, ...props }) => {
  const isMobileDevice = useBreakpointInfo([MediaBreakpoint.BELOW_MID_DESKTOP]);

  if (games.length < TALL_WIDE_LAYOUT_GAMES_COUNT) return null;
  const [firstGame, secondGame, thirdGame] = games;

  if (isMobileDevice) {
    return (
      <Grid columns={1} gap="s" className="game-grid game-grid--tall-mobile">
        <GridItem>{renderGameCard(firstGame, GameCardContainerType.Wide, 'tall-hero', props)}</GridItem>
        <GridItem>
          <Grid columns={2} gap="s" className="tall-mobile-boxes">
            <GridItem>{renderGameCard(secondGame, GameCardContainerType.Box, 'tall-1', props)}</GridItem>
            <GridItem>{renderGameCard(thirdGame, GameCardContainerType.Box, 'tall-2', props)}</GridItem>
          </Grid>
        </GridItem>
      </Grid>
    );
  }

  return (
    <Grid columns={2} gap="s" className="game-grid game-grid--tall">
      <GridItem row={1} startCol={1} endCol={2}>
        {renderGameCard(firstGame, GameCardContainerType.Tall, 'tall-hero', props)}
      </GridItem>
      <GridItem row={1} startCol={2} endCol={3}>
        {renderGameCard(secondGame, GameCardContainerType.Box, 'tall-1', props)}
      </GridItem>
      <GridItem row={2} startCol={2} endCol={3}>
        {renderGameCard(thirdGame, GameCardContainerType.Box, 'tall-2', props)}
      </GridItem>
    </Grid>
  );
};

export const TallReverseLayout: FC<TallLayoutProps> = ({ games, getCompositeKey, ...props }) => {
  const isMobileDevice = useBreakpointInfo([MediaBreakpoint.BELOW_MID_DESKTOP]);

  if (games.length < TALL_WIDE_LAYOUT_GAMES_COUNT) return null;
  const [firstGame, secondGame, thirdGame] = games;

  if (isMobileDevice) {
    return (
      <Grid columns={1} gap="s" className="game-grid game-grid--tall-reverse-mobile">
        <GridItem>
          <Grid columns={2} gap="s" className="tall-mobile-boxes">
            <GridItem>{renderGameCard(firstGame, GameCardContainerType.Box, 'tall-reverse-1', props)}</GridItem>
            <GridItem>{renderGameCard(secondGame, GameCardContainerType.Box, 'tall-reverse-2', props)}</GridItem>
          </Grid>
        </GridItem>
        <GridItem>{renderGameCard(thirdGame, GameCardContainerType.Wide, 'tall-reverse-hero', props)}</GridItem>
      </Grid>
    );
  }

  return (
    <Grid columns={2} gap="s" className="game-grid game-grid--tall-reverse">
      <GridItem row={1} startCol={1} endCol={2}>
        {renderGameCard(firstGame, GameCardContainerType.Box, 'tall-reverse-0', props)}
      </GridItem>
      <GridItem row={2} startCol={1} endCol={2}>
        {renderGameCard(secondGame, GameCardContainerType.Box, 'tall-reverse-1', props)}
      </GridItem>
      <GridItem row={1} startCol={2} endCol={3}>
        {renderGameCard(thirdGame, GameCardContainerType.Tall, 'tall-reverse-hero', props)}
      </GridItem>
    </Grid>
  );
};
